const CACHE_NAME = "storageV1"
const saveToCache=(url,blob,onSuccess=()=>{},onError=()=>{})=>{
  if("caches" in window){
    caches.open(CACHE_NAME).then(cache=>{
      let req=new Request(url)
      let res=new Response(blob)
      cache.put(req,res).then(()=>onSuccess())
    }).catch(e=>onError(e))
  }
}


const getFromCache=(url,onResult=()=>{},onError=()=>{})=>{
  if("caches" in window){
    caches.open(CACHE_NAME).then(cache=>{
      cache.match(url).then(res=>onResult(res)).catch(e=>onError(e))
    })
  }
}
const deleteCache=(url,onResult=()=>{},onError=()=>{})=>{
  if("caches" in window){
    caches.open(CACHE_NAME).then(cache=>{
      cache.delete(url).then(res=>onResult(res)).catch(e=>onError(e))
    })
  }
}


const setImgFromCache=(url,imgId,onSuccess=()=>{},onError=()=>{})=>{
  if("caches" in window){
    caches.open(CACHE_NAME).then(cache=>{
      cache.match(url).then(res=>{
        if(!!res){
          return res.blob()
        }else{
          throw new Error("Tidak ditemukan")
        }
      }).then(b=>{
        if( typeof imgId === "string"){
          document.getElementById(imgId).src = URL.createObjectURL(b);
        }else if (!!imgId?.current){
          imgId.current.src = URL.createObjectURL(b);
        }
        onSuccess()
      }).catch(e=>onError(e))
    })
  }
  /* getFromCache(url,(r)=>{
    r.blob().then(b=>{
      document.getElementById(imgId).src = URL.createObjectURL(b);
    })
  },e=>onError(e)) */
}
export {saveToCache,getFromCache,deleteCache,setImgFromCache}